import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "position",
  "data-test": "position"
}
const _hoisted_2 = { "data-test": "position-heading" }
const _hoisted_3 = { class: "position__company" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_5 = { class: "position__job-title" }
const _hoisted_6 = {
  "data-test": "position-dates",
  class: "position__dates"
}
const _hoisted_7 = {
  class: "position__responsibilities",
  "data-test": "position-list-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UtilityHTMLContentRenderer = _resolveComponent("UtilityHTMLContentRenderer")!
  const _component_UtilityDetailList = _resolveComponent("UtilityDetailList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.company) + ", " + _toDisplayString(_ctx.location), 1),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.jobTitle), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.startDate) + " - " + _toDisplayString(_ctx.endDate), 1),
    (_ctx.description)
      ? (_openBlock(), _createBlock(_component_UtilityHTMLContentRenderer, {
          key: 0,
          class: "position__description",
          "data-test": "position-description",
          content: _ctx.description
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_UtilityDetailList, { items: _ctx.responsibilities }, null, 8, ["items"])
    ])
  ]))
}